import axios from "axios";
import firebase from "firebase/compat/app";
import { isNullOrEmpty } from "../config/ENV";
import { toast } from "react-toastify";
toast.configure();

const requestHandler = (request) => {
  document.body.classList.add("loading-indicator");
  const token = window.localStorage.getItem("authToken");
  if (token) {
    request.headers["Authorization"] = "Bearer " + token;
  }
  request.headers["Content-Type"] = "application/json";
  return request;
};

const responseHandler = (response) => {
  document.body.classList.remove("loading-indicator");
  return response;
};

const AxiosInterceptors = axios.create({});

AxiosInterceptors.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => errorHandler(error)
);

AxiosInterceptors.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => errorHandler(error)
);

const errorHandler = (error) => {
  document.body.classList.remove("loading-indicator");
  console.log("error" + JSON.stringify(error));

  if (error.code === "ERR_NETWORK") {
    toast.error("Internal Server Error");
  } else {
    const status = error.response.status;
    const failure_code = error.response.data.failure_code;

    console.log("failure_code" + JSON.stringify(failure_code));
    console.log("status" + JSON.stringify(status));

    if (status === 400) {
      handleFailureCode(failure_code);
    } else if (status == 401) {
      if (failure_code === "INVALID_USER") {
        window.location.href = "/";
      } else if (failure_code === "INVALID_USER_SESSION") {
        sessionExpired();
      } else if (
        failure_code === "INVALID_BEARER_TOKEN" ||
        failure_code === "MISSING_BEARER_TOKEN"
      ) {
        sessionExpired();
      }
    } else if (status === 404) {
      window.localStorage.setItem("account", "NewUser");
      window.location.href = "/";
    } else if (status === 409) {
      if (failure_code === "ACCOUNT_EXISTS") {
        toast.error("Account already exists");
        logoutFirebase();
      }
    }
  }
  return Promise.reject(error);
};

const sessionExpired = () => {
  const query = new URLSearchParams(window.location.search);
  const hmsId = query.get("id");

  if (!isNullOrEmpty(window.localStorage.getItem("user"))) {
    clearStorage();
  } else if (!isNullOrEmpty(window.localStorage.getItem("account"))) {
    clearStorage();
  } else if (!isNullOrEmpty(hmsId)) {
    clearStorage();
  } else {
    window.localStorage.clear();
    sessionStorage.clear();
  }
};

const handleFailureCode = (failure_code) => {
  if (failure_code === "ACCOUNT_IN_USE") {
    toast.error("Account in use");
  }
  if (failure_code === "ACCOUNT_ADDRESS_IN_USE") {
    toast.error("Account address in use");
  }
  if (failure_code === "ACCOUNT_BENEFITS_IN_USE") {
    toast.error("Account benefits in use");
  }
  if (failure_code === "DISPLAY_NAME_ALREADY_USED") {
    toast.error("Display name already used");
  }
};

const clearStorage = () => {
  if (isNullOrEmpty(window.localStorage.getItem("isLogout"))) {
    toast.error("Session Expired. Login again");
  }
  window.localStorage.clear();
  sessionStorage.clear();
  firebase
    .auth()
    .signOut()
    .then(function () {
      window.location.href = "/";
    })
    .catch(function () {
      window.location.href = "/";
    });
};

const logoutFirebase=()=>{
  window.localStorage.clear();
  sessionStorage.clear();
  firebase
    .auth()
    .signOut()
    .then(function () {
     const timer = setTimeout(() =>{
      window.location.href = "/";
    }, 1000);
    })
    .catch(function () {
      window.location.href = "/";
    });
}

export default AxiosInterceptors;
